module.exports = __webpack_public_path__ + "static/img/tr.ed6d5f37.svg";